import { Injectable } from '@angular/core';
import { randomNumber } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class UserMockService {
  private _colors: any[] = [
    {
      text: '#3699FF',
      bg: 'rgba(54, 153, 255, 0.15)',
    },
    {
      text: '#2DC64F',
      bg: 'rgba(45, 198, 79, 0.15)',
    },
    {
      text: '#FFBB36',
      bg: 'rgba(255, 187, 54, 0.15)',
    },
  ];

  private MOCK_LIST: any = [
    {
      id: 1,
      full_name: 'Brad Simmons',
      tel: '+34 919 930 917',
      email: 'brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 2,
      full_name: 'Jessie Clarcson',
      tel: '+34 919 900 014',
      email: '1brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 3,
      full_name: 'Lebron Wayde',
      tel: '+34 919 184 200',
      email: '2brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 4,
      full_name: 'Hayes Boule',
      tel: '+34 919 220 347',
      email: '3brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 5,
      full_name: 'Kip Pendrill',
      tel: '+34 919 030 645',
      email: '4brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 6,
      full_name: 'Sandra Maidens',
      tel: '+34 919 732 902',
      email: '5brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 7,
      full_name: 'Fitz Werndley',
      tel: '+34 919 220 212',
      email: '6brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 8,
      full_name: 'Sharleen Gaskin',
      tel: '+34 919 030 876',
      email: '7brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 9,
      full_name: 'Tierney Aysh',
      tel: '+34 919 460 645',
      email: '8brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 10,
      full_name: 'Devonne Degan',
      tel: '+34 919 460 645',
      email: '9brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 11,
      full_name: 'Brad Simmons 2',
      tel: '+34 919 930 917',
      email: '10brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 12,
      full_name: 'Jessie Clarcson 2',
      tel: '+34 919 900 014',
      email: '11brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 13,
      full_name: 'Lebron Wayde 2',
      tel: '+34 919 184 200',
      email: '12brad.simmons@gmail.com',
      colors: this._setColor(),
    },
    {
      id: 14,
      full_name: 'Hayes Boule 2',
      tel: '+34 919 220 347',
      email: '13brad.simmons@gmail.com',
      colors: this._setColor(),
    },
  ];

  getUsers(): any[] {
    return this.MOCK_LIST;
  }

  getUserById(id: number): any {
    return this.MOCK_LIST.find((i: any) => i.id === id);
  }

  create(patient: any) {
    this.MOCK_LIST.unshift(patient);
  }

  private _setColor(): any {
    return this._colors[randomNumber(0, this._colors.length - 1)];
  }
}
